module.exports = __webpack_public_path__ + "img/image-0.51561ab4.png";